import React from 'react';
import {Head} from 'react-static';

export default function PageMeta({
  url = 'https://grow.foodrevolution.org/',
  ogImage = 'https://cdn.foodrevolution.org/tntg/social/tntg-open-graph-202106-1200x630.jpg',
  title = 'The Need To GROW | Watch the full film – free!',
  description = 'Can we feed the world without destroying it?! Rosario Dawson’s award-winning film The Need To GROW shows the SOLUTIONS — and the real stories of the game-changing innovators behind them.',
  ...props
}) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:site" content="theneedtogrow" />
      <meta property="twitter:image" content={ogImage} />
      <meta property="fb:app_id" content="731824260184014" />
      <meta property="og:site_name" content="The Need To GROW" />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
    </Head>
  );
}
